module.exports = __webpack_public_path__ + "img/InShot-icon.435b5e26.png";